import './Exterior.scss';
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import Fade from '@/v2/components/atoms/Fade';
import Header from '@/v2/components/application/Header';
import Disclaimer from '@/v2/components/layouts/Disclaimer';
import { DesignContext, ApplicationContext } from '@/v2/state/providers';

const Exterior = ({ isActive, onReady }) => {
    const [{ disclaimer }] = useContext(DesignContext);
    const [{ visualizer }] = useContext(ApplicationContext);
    const {
        colors,
        ctaLabel,
        ctalink,
        defaultCarColor,
        disclaimerLabel,
        disclaimerText,
        drivemode,
        logoAltText,
        showLessText,
        showMoreText,
        stickyNavId,
        toggleLightText,
        urlRedirect,
        visualiserBodyCopy,
        visualiserLogo,
        visualizerBaseAssetPath,
        visualizerURL,
    } = visualizer;

    // to test viz locally, update the viz paths in mock data: application.json as per development/ master viz reference.
    const visualizerConfigs = {
        baseAssetsPath: visualizerBaseAssetPath,
        colors: JSON.stringify(colors),
        ctaLabel,
        ctaLess: showLessText,
        ctaLights: toggleLightText,
        ctaMore: showMoreText,
        ctalink,
        defaultCarColor,
        disclaimerLabel,
        disclaimerText: JSON.stringify(disclaimerText),
        drivemode,
        hideControlButtons: true,
        loaderOffCenter: true,
        loaderText: 'awaken ariya', // TODO: remove after received from AEM
        rolloutNewDesign: true, // TODO: remove after received from AEM
        stickyNavId,
        urlRedirect,
        visualiserBodyCopy,
        visualiserLogo,
        visualiserLogoAlt: logoAltText,
    };

    const addUrlToScript = (url, defer) => {
        const script = document.createElement('script');

        script.defer = defer;
        script.src = url;
        script.type = 'text/javascript';

        document.body.appendChild(script);
    };

    useEffect(() => {
        onReady();

        const scripts = document.querySelectorAll('script');
        const scriptsArr = Array.from(scripts);

        const scriptAlreadyAdded = scriptsArr.some((script) => script.src.includes(visualizerURL));

        if (!scriptAlreadyAdded) addUrlToScript(visualizerURL, true);
    }, []);

    const fadeContent = <Fade cover slow show={!isActive} />;
    const visualizerContent = <visualiser-360 componentID="Nav123456" {...visualizerConfigs} />;
    const headerContent = <Header animate show={isActive} hideLogo />;
    const disclaimerContent = isActive && disclaimer ? <Disclaimer data={disclaimer} dark /> : null;

    return (
        <div className="Exterior">
            {fadeContent}
            {visualizerContent}
            {headerContent}
            {disclaimerContent}
        </div>
    );
};

export default withRouter(Exterior);
